import { LitElement, html, svg } from 'lit';

export class IconAttachment32 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><title>Binders</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19.9 7.333 7.88 19.36A3 3 0 0 0 12.12 23.6l12.02-12.027a6 6 0 1 0-8.484-8.484L3.636 15.11a9 9 0 0 0 12.728 12.728L30.831 13.37"></path></svg>`; }
}
if (!customElements.get('f-icon-attachment32', IconAttachment32)) {
  customElements.define('f-icon-attachment32', IconAttachment32);
}